module.exports = __webpack_public_path__ + "img/badge-list-thumb-057.799bde1b.png";